import { useMemo } from 'react';
import { useWindowSize } from 'react-use';

interface UseGetDatatableCoreHeightArgs {
  isPaginationEnabled: boolean;
  heightOffset: number;
}

export const useGetDatatableCoreHeight = ({
  isPaginationEnabled,
  heightOffset,
}: UseGetDatatableCoreHeightArgs) => {
  const pageContainerPadding = 28;
  const headingHeight = 38;
  const headingMargin = 25;
  const paginationMarging = isPaginationEnabled ? 14 : 0;
  const paginationHeight = isPaginationEnabled ? 28 : 0;
  const tableCoreMarginBottom = 14;
  const appHeaderHeight = 48;

  const { height: innerHeight } = useWindowSize();

  return useMemo(
    () =>
      innerHeight -
      (appHeaderHeight +
        2 * pageContainerPadding +
        headingHeight +
        headingMargin +
        2 * paginationMarging +
        paginationHeight +
        tableCoreMarginBottom +
        heightOffset),
    [
      innerHeight,
      appHeaderHeight,
      pageContainerPadding,
      headingHeight,
      headingMargin,
      paginationMarging,
      paginationHeight,
      tableCoreMarginBottom,
      heightOffset,
    ],
  );
};
